import { createFileRoute } from "@tanstack/react-router"
import { ScheduleRunHistory } from "../components/settings/schedule-run-history"
import { useScheduledJobs, useScheduledJobRuns } from "../services/use-scheduled-jobs"
function RunsPage() {
  const { jobId } = Route.useParams()
  const jobs = useScheduledJobs()
  const runs = useScheduledJobRuns(jobId)
  const job = jobs.data?.find((candidate) => candidate.id === jobId)
  return job ? (
    <ScheduleRunHistory
      runs={runs.data ?? []}
      timeZone={job.schedule.timeZone}
      isLoading={runs.isLoading}
      error={runs.error}
    />
  ) : null
}
export const Route = createFileRoute("/settings/schedules/$jobId/")({ component: RunsPage })
